import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  IconButton,
  Paper,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddIcon from "@mui/icons-material/Add";
import { feedbackMockData } from "../../constants";
import FeedbackForm from "./FeedbackForm";
import CustomButton from "components/CustomButton";
import IFeedback from "models/Feedback";
import ViewFeedbackModal from "./ViewFeedbackModal";
import { FeedbackActionButton } from "components/ActionButton/FeedbackActionButton";

const FeedbackComponent: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [formOpen, setFormOpen] = useState<boolean>(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState<IFeedback>();
  const open = Boolean(anchorEl);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFeedbackFormOpen = (e: React.MouseEvent<HTMLElement>) => {
    setFormOpen(true);
  };

  const handleFeedbackFormClose = () => {
    setFormOpen(false);
  };

  const handleViewDetails = (feedback:any) => {
    setSelectedFeedback(feedback);
    setViewDetails(true);
  };

  const handleCloseDetails = () => {
    setSelectedFeedback(null);
    setViewDetails(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" sx={{ fontSize: "20px", fontWeight: 800, opacity: 0.8 }}>
          Feedback
        </Typography>
        <CustomButton
          startIcon={<AddIcon />}
          title="Give feedback"
          onClick={handleFeedbackFormOpen}
        />
      </Box>
      <Box>
        <TableContainer component={Paper} elevation={3}>
          <Table sx={{ minWidth: 580 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">
                  <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                    Review
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                    Details
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                    Action
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {feedbackMockData.slice(0, 3).map(({ name, avatar, title, date, feedback }) => (
                <TableRow key={name} sx={{ minHeight: "50px" }}>
                  <TableCell component="th" scope="row">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar src={avatar} sx={{ width: 40, height: 40 }} />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          ml: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "14px",
                            fontWeight: 800,
                            opacity: 0.8,
                          }}
                        >
                          {name}
                        </Typography>
                        <Typography variant="h6" sx={{ fontSize: "12px", opacity: 0.8 }}>
                          {title}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        color: "black",
                        backgroundColor: "#F5F6F9",
                        borderColor: "gray",
                        opacity: 0.7,
                        whiteSpace: "nowrap",
                        "&:hover": { borderColor: "gray" },
                      }}
                      onClick={() => handleViewDetails({ name, avatar, title, date, feedback })}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "12px",
                          fontWeight: "800",
                          textTransform: "none",
                          opacity: 0.8,
                        }}
                      >
                        View details
                      </Typography>
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <IconButton onClick={(e) => handleMenuOpen(e)}>
                      <MoreHorizIcon
                        sx={{
                          backgroundColor: "#F5F6F9",
                          width: 26,
                          height: 26,
                          borderRadius: "100%",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <FeedbackActionButton anchorEl={anchorEl} open={open} handleClose={handleMenuClose} />
      <FeedbackForm formOpen={formOpen} handleFeedbackFormClose={handleFeedbackFormClose} />
      {selectedFeedback && (
        <ViewFeedbackModal
          viewDetails={viewDetails}
          handleCloseDetails={handleCloseDetails}
          selectedFeedback={selectedFeedback}
        />
      )}
    </Box>
  );
};

export default FeedbackComponent;
